<template>
  <div id="callback">
    <h1>Votre commande a bien été prise en compte. Merci pour votre confiance.</h1>
  </div>
</template>

<script>
  export default {
    data() {
      return {
      };
    },
    created() {
    },
  };
</script>

<style lang="scss">
#callback {
  text-align: center;
  margin:3em 0;
  h1 {

  }
}
</style>
